import { Component, TemplateRef, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { catchError, map, merge, startWith, switchMap } from 'rxjs';
import { InvoiceService } from 'src/app/private/services/invoice.service';
import { UsersService } from 'src/app/private/services/users.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { TrackingService } from 'src/app/private/services/tracking.service';
import { CompanyService } from 'src/app/private/services/company.service';
import { applyCenterScopeToWhere } from 'src/app/utils/tenant-scope.util';

@Component({
  selector: 'app-invoice',
  templateUrl: './invoice.component.html',
  styleUrls: ['./invoice.component.scss']
})
export class InvoiceComponent {

  searchQuery = new FormControl();
  @ViewChild(MatPaginator)
  paginator!: MatPaginator;

  @ViewChild(MatSort)
  sort!: MatSort;

  @ViewChild('invoicePaymentReturnTpl')
  invoicePaymentReturnTpl!: TemplateRef<unknown>;

  /** Set before opening CCAvenue return popup */
  invoicePaymentReturnKind: 'success' | 'failed' = 'success';

  dateQuery = new FormControl();
  center_id: any;
  totalRows = 0;
  temp: any = [];
  dataSource: MatTableDataSource<any> = new MatTableDataSource();
  formAction = 'Add';
  currentPage = 0;
  pageSize = 25;
  pageSizeOptions: number[] = [10, 25, 100];
  btnLoading: boolean = false;
  reloading: boolean = false;
  initialLoad: boolean = true;
  closeResult = '';
  editData: any;
  deleteData: any;
  users: any = [];
  currencyCode: any;
  current_id_hover = '';
  infoArray: any = [];
  isToggled: boolean = false;
  isSaving: boolean = false;
  sendInvoiceFromEmail = '';
  sendInvoiceToEmail = '';
  sendInvoiceEmailProvider = '';

  isAdmin: boolean = false;

  displayedColumns: string[] = [
    "invoice_number",
    "account_name",
    "total",
    "paid_amount",
    "balance_due",
    "status",
    "invoice_type",
    "issue_date",
    "due_date",
    "documents",
    "action"
  ];

  defaultFilter = [
    "invoice_number",
    "client_name",
    "account_name",
    "total",
    "status",
    "issue_date",
    "due_date",
    "balance_due"
  ];

  importColumnsArray: any = [
    { key: 'invoice_number', value: 'Invoice Number' },
    { key: 'client_name', value: 'Client Name' },
    { key: 'account_name', value: 'Account Name' },
    { key: 'total', value: 'Total Amount' },
    { key: 'status', value: 'Status' },
    { key: 'issue_date', value: 'Issue Date' },
    { key: 'due_date', value: 'Due Date' },
    { key: 'balance_due', value: 'Balance Due' },
  ];

  constructor(
    private localStorage: LocalStorageService,
    private api: InvoiceService,
    private modalService: NgbModal,
    private toast: ToastrService,
    private userApi: UsersService,
    private tracker: TrackingService,
    private companyService: CompanyService,
    private route: ActivatedRoute,
    private router: Router
  ) {

    this.isAdmin = this.localStorage.checkFullAccessForTableList(
      this.localStorage.getRole()
    );
  }

  handleShowCanban(event: any) {
    this.isToggled = event;
  }

  ngAfterViewInit() {
    console.log("table column : ", this.displayedColumns);
    this.currencyCode = this.localStorage.getClientCurrency();

    const payment = this.route.snapshot.queryParamMap.get('payment');
    if (payment === 'success_payment' || payment === 'failed_payment') {
      const kind = payment === 'success_payment' ? 'success' : 'failed';
      this.router
        .navigate([], {
          relativeTo: this.route,
          queryParams: {},
          replaceUrl: true,
        })
        .then(() => {
          this.loadData();
          setTimeout(() => this.openInvoicePaymentReturnPopup(kind), 0);
        });
      return;
    }

    this.loadData();
  }

  /** After CCAvenue redirect: ?payment=success_payment | failed_payment */
  openInvoicePaymentReturnPopup(kind: 'success' | 'failed'): void {
    if (!this.invoicePaymentReturnTpl) {
      return;
    }
    this.invoicePaymentReturnKind = kind;
    this.modalService.open(this.invoicePaymentReturnTpl, {
      centered: true,
      size: 'md',
      scrollable: true,
      backdrop: 'static',
    });
  }

  ngOnInit(): void {
    this.getAllUsers();
  }

  getAllUsers() {
    let param = {
      client_id: this.localStorage.getClientId(),
    };
    this.userApi.findAllUsers(param).subscribe({
      next: (res: any) => {
        this.users = res || [];
      },
      error: (e: any) => {
        console.error(e);
      },
    });
  }

  open(content: any) {
    this.formAction = 'Add';

    this.modalService.open(content, {
      size: 'xl', scrollable: true,
      centered: true
    })
  }

  loadData() {
    try {
      merge(
        this.paginator.page,
        this.searchQuery.valueChanges,
        this.sort.sortChange
      )
        .pipe(
          startWith({}),
          switchMap(() => {
            this.reloading = true;

            console.log("client_id", this.localStorage.getClientId())
            let param: any = {
              "page": this.paginator.pageIndex * this.paginator.pageSize,
              "limit": this.paginator.pageSize,
              where: {
                client_id: this.localStorage.getClientId(),
              },
              "order": {
                "col": "\"invoice\".\"updatedAt\"",
                "dir": "DESC"
              }
            }

            if (this.searchQuery.value) {

              for (let [key, value] of Object.entries(this.searchQuery.value)) {

                if (this.defaultFilter.includes(key)) {

                  if (key == 'total' || key == 'paid_amount' || key == 'balance_due') {
                    param.where[key] = Number(value);
                  } else {
                    param.where[key] = value;
                  }
                }
              }
            }

            return this.api.getAllInvoice(param).pipe(catchError(() => {
              this.reloading = false;
              this.initialLoad = false;
              return [];
            }));
          }),
          map((data: any) => {

            this.reloading = false;
            this.initialLoad = false;

            if (data) {
              this.totalRows = data.count || 0;
              return data.rows || [];
            } else {
              this.totalRows = 0;
              return [];
            }
          }),
        ).subscribe((data: any) => {
          this.dataSource.data = data;
        });
    } catch (error) {
      this.reloading = false;
      this.initialLoad = false;
    }
  }

  reloadData() {
    this.reloading = true;
    try {
      merge()
        .pipe(
          startWith({}),
          switchMap(() => {
            this.reloading = true;

            console.log("client_id", this.localStorage.getClientId())
            let param: any = {
              "page": this.paginator.pageIndex * this.paginator.pageSize,
              "limit": this.paginator.pageSize,
              where: {
                client_id: this.localStorage.getClientId(),
              },
              "order": {
                "col": "\"invoice\".\"updatedAt\"",
                "dir": "DESC"
              }
            }

            if (this.searchQuery.value) {

              for (let [key, value] of Object.entries(this.searchQuery.value)) {

                if (this.defaultFilter.includes(key)) {

                  if (key == 'total' || key == 'paid_amount' || key == 'balance_due') {
                    param.where[key] = Number(value);
                  } else {
                    param.where[key] = value;
                  }
                }
              }
            }

            return this.api.getAllInvoice(param).pipe(catchError(() => {
              this.reloading = false;
              this.initialLoad = false;
              return [];
            }));
          }),
          map((data: any) => {

            this.reloading = false;
            this.initialLoad = false;

            if (data) {
              this.totalRows = data.count || 0;
              return data.rows || [];
            } else {
              this.totalRows = 0;
              return [];
            }
          }),
        ).subscribe((data: any) => {
          this.dataSource.data = data;
        });
    } catch (error) {
      this.reloading = false;
      this.initialLoad = false;
    }
  }

  openEdit(content: any, data: any) {
    this.formAction = 'Update';
    this.editData = data;
    this.modalService.open(content, {
      size: 'xl', scrollable: true,
      centered: true
    })
  }

  openDeleteEvent(content: any, data: any) {
    this.deleteData = data;
    this.modalService.open(content, {
      size: 'md', scrollable: true,
      centered: true
    })
  }

  searchFilter(query: any) {
    console.log('Search Query:', query);
    this.searchQuery.setValue(query);
  }

  handleDeleteInvoice() {

    const params = {
      "id": this.deleteData.id,
      "client_id": this.localStorage.getClientId()
    }
    this.btnLoading = true;
    this.api.deleteInvoice(params).subscribe((res: any) => {
      console.log('Response:', res);
      this.toast.success('Invoice Deleted Successfully');

      const desc = `Invoice deleted with number: ${this.deleteData.invoice_number} and id: ${this.deleteData.id}`;
      this.tracker.track("Delete", "Invoice", desc);
      this.reloadData();
      this.btnLoading = false;
      this.modalService.dismissAll();
    })
  }

  updateHoverState(id: string): void {
    this.current_id_hover = id;
  }

  openSendInvoice(content: any, data: any) {
    this.editData = data;
    this.sendInvoiceFromEmail = this.localStorage.getSendEmailFromAddress();
    this.sendInvoiceEmailProvider = this.localStorage.getEmailProviderTypeForPayload();
    this.sendInvoiceToEmail = this.resolveAccountEmail(data);
    this.modalService.open(content, {
      size: 'md', 
      scrollable: true,
      centered: true
    });

    if (!this.sendInvoiceToEmail && data?.account_id) {
      this.loadInvoiceAccountEmail(data.account_id);
    }
  }

  private resolveAccountEmail(data: any): string {
    return String(
      data?.account?.email ||
      data?.account?.fields?.email ||
      data?.account_email ||
      data?.email ||
      ''
    ).trim();
  }

  private loadInvoiceAccountEmail(accountId: any): void {
    const params = {
      page: 0,
      limit: 1,
      where: applyCenterScopeToWhere(
        {
          client_id: this.localStorage.getClientId(),
          account_id: accountId,
        },
        this.localStorage
      ),
      order: {
        col: '"account"."updatedAt"',
        dir: 'DESC',
      },
    };

    this.companyService.getAllCompany(params).subscribe({
      next: (response: any) => {
        const account = response?.rows?.[0];
        this.sendInvoiceToEmail = this.resolveAccountEmail({ account });
        if (account && this.editData) {
          this.editData.account = { ...this.editData.account, ...account };
        }
      },
      error: (error: any) => {
        console.error('Failed to load invoice account email:', error);
      },
    });
  }

  handleSendInvoice() {
    if (!this.editData) return;
    if (!this.sendInvoiceEmailProvider || !this.sendInvoiceFromEmail) {
      this.toast.error('Set an email preference or connect an email account before sending');
      return;
    }
    if (!this.sendInvoiceToEmail) {
      this.toast.error('The selected account does not have an email address');
      return;
    }

    this.btnLoading = true;
    const params = {
      id: this.editData.id,
      client_id: this.localStorage.getClientId(),
      companyName:
        this.editData?.account?.account_name ||
        this.editData?.company_name ||
        undefined,
      emailProviderType: this.sendInvoiceEmailProvider,
      from_email: this.sendInvoiceFromEmail,
    };

    this.api.sendInvoice(params).subscribe({
      next: (res: any) => {
        this.toast.success('Invoice Sent Successfully');
        const desc = `Invoice sent with number: ${this.editData.invoice_number} and id: ${this.editData.id}`;
        this.tracker.track("Send", "Invoice", desc);
        this.reloadData();
        this.btnLoading = false;
        this.modalService.dismissAll();
      },
      error: (err: any) => {
        this.toast.error(err.error?.message || 'Failed to send invoice');
        this.btnLoading = false;
      }
    });
  }

  handleDownloadInvoice(element: any) {
    const toastRef = this.toast.info('Downloading invoice...', '', {
      disableTimeOut: true,
      positionClass: 'toast-top-right'
    });

    const params = {
      invoice_id: element.id
    };

    this.api.generateInvoice(params).subscribe({
      next: (res: any) => {
        this.toast.clear(toastRef.toastId);

        const fileUrl = res.fileUrl || res.file_url;
        const filename = `${res.invoice_number || 'invoice'}.pdf`;

        if (res.success && res.pdfBase64) {
          // Convert base64 to blob
          const byteCharacters = atob(res.pdfBase64);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: 'application/pdf' });

          // Create download link
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = filename;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);

          this.toast.success('Invoice downloaded successfully', '', {
            positionClass: 'toast-top-right'
          });

          const desc = `Invoice downloaded with number: ${res.invoice_number} and id: ${res.invoice_id}`;
          this.tracker.track("Download", "Invoice", desc);
        } else if (res.success && fileUrl) {
          const link = document.createElement('a');
          link.href = fileUrl;
          link.target = '_blank';
          link.rel = 'noopener noreferrer';
          link.download = filename;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          this.toast.success('Invoice downloaded successfully', '', {
            positionClass: 'toast-top-right'
          });

          const desc = `Invoice downloaded with number: ${res.invoice_number} and id: ${res.invoice_id}`;
          this.tracker.track("Download", "Invoice", desc);
        } else {
          this.toast.error('Failed to generate PDF', '', {
            positionClass: 'toast-top-right'
          });
        }
      },
      error: (err: any) => {
        this.toast.clear(toastRef.toastId);
        this.toast.error(err.error?.message || 'Failed to download invoice', '', {
          positionClass: 'toast-top-right'
        });
      }
    });
  }

  openExternalUrl(url: string | null | undefined): void {
    if (!url) return;
    window.open(url, '_blank', 'noopener,noreferrer');
  }
}
